<script setup>
import { computed, inject } from 'vue'
import { getPrettyPrice, getCashPrice, getCardPrice } from '../shared/utils'
import { useModal, useModalSlot } from 'vue-final-modal'
import ModalFull from './ModalFull.vue'
import useCartStore from '../store/cart'
import { RouterView } from 'vue-router'
import router from '../routes';
import { useCheckoutModal } from '@client/js/composables/useCheckoutModal';

let rootData = inject('rootData');
const cartStore = useCartStore();

const emit = defineEmits(['close']);

let total = computed(() => cartStore.checkoutTotal );

const { open: _open, close: _close } = useCheckoutModal();

// const { open: _open, close: _close } = useModal({
//   component: ModalFull,
//   keepAlive: true,
//   attrs: {
//     onClose(e, d) {
//       handleClose();
//     },
//   },
//   slots: {
//     default: useModalSlot({
//       component: RouterView,
//     })
//   }
// })

// let returnTo = null     // modal router: return to page

function handleOpen() {
  router.push({ name: 'cart' })
  _open()
}

// Modal Close handler that wrapping close() and route modify
// function handleClose () {
//   _close()

//   if (returnTo) {
//     router.push(returnTo)          // normal open
//     returnTo = null
//   } else if (window.history.state && window.history.state.back !== null) {
//     router.back()                  // direct open when history exists
//   } else {
//     router.push('/')               // first open - go home url
//   }
// }

</script>

<template>
  <div v-show="cartStore.count > 0" class="cart-widget" @click="handleOpen()">
    <div class="cart-widget__label">
      <div class="cart-widget__label-line"><strong>Cart</strong></div>
      <div class="cart-widget__label-line" data-note="+tax">
        <template v-if="rootData.dualpricing">
            <div v-text="getPrettyPrice(getCardPrice(total))"></div>
            <div v-text="getPrettyPrice(getCashPrice(total))"></div>
        </template>
        <template v-else>
            <div v-text="getPrettyPrice(total)"></div>
        </template>
      </div>
    </div>
    <div class="cart-widget__badge">
      <svg class="cart-widget__icon" width="32" height="29" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMin meet" aria-hidden="true">
        <path d="M4.68 28.76c.2.98 1.07 1.7 2.08 1.7h20.48c1 0 1.88-.71 2.08-1.7v-.03l.03-.1.07-.37.27-1.35.81-4.06.82-4.06.27-1.34.07-.38.01-.06A2.12 2.12 0 0 0 33.12 15v-1.33c0-1.18-.95-2.13-2.12-2.13H3c-1.17 0-2.13.95-2.13 2.13V15c0 .93.6 1.73 1.46 2.01l2.35 11.75Zm2.08.11a.54.54 0 0 1-.53-.43L3.97 17.12h26.06l-2.26 11.32a.55.55 0 0 1-.53.43H6.76Zm-4.3-15.2c0-.3.24-.55.54-.55h28c.3 0 .54.25.54.55V15c0 .3-.24.54-.54.54H3a.54.54 0 0 1-.54-.54v-1.33ZM5.1 9.1a.8.8 0 0 0 1.13 1.13l8-8A.8.8 0 0 0 13.1 1.1l-8 8ZM27.77 10.23A.8.8 0 0 0 28.9 9.1l-8-8a.8.8 0 0 0-1.12 1.12l8 8Z" fill="currentColor" stroke="currentColor" stroke-width="0.25" />
      </svg>
      <div class="cart-widget__count" v-text="cartStore.count"></div>
    </div>
  </div>
</template>

<style lang="scss">
.cart-widget {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  text-decoration: none;
  background-color: var(--c-primary);
  color: white;
  bottom: 0;
  left: 0;
  width: 100%;
  position: fixed;
  height: 61px;
  cursor: pointer;
  z-index: 1;
  
  @media (min-width: 360px) and (max-width: 479px) {
    width: calc(100% - 1rem);
    margin: 0.5rem;
  }
  @media (min-width: 479px) and (max-width: 1279px) {
    width: calc(100% - 1rem);
    margin: 0.5rem auto;
    max-width: min(100% - 1rem, 480px);
    left: 50%;
    transform: translateX(-50%);
  }
  @media (max-width: 1279px) {
    border-radius: 0.25rem;
  }

  @media (min-width: 1280px) {
    width: auto;
    border-radius: 9999px 0 0 9999px;
    overflow: hidden;
    justify-content: flex-start;
    height: 72px;
    position: absolute;
    width: 50vw;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      display: block;
      background-color: rgba(0, 0, 0, 0.15);
      z-index: -1;
    }
  }

  &__label-line {
    display: flex;
    align-items: flex-end;

    &[data-note]::after {
      content: attr(data-note);
      display: inline-flex;
      font-size: 0.7rem;
    }

    div {
      position: relative;
      padding-left: .375rem;
      padding-right: .375rem;

      &:first-child {
        padding-left: 0;
      }

      padding-right: .375rem;

      &:first-child:not(:last-child) {
        padding-right: .375rem;

        &::after {
          content: "";
          width: 1px;
          height: 100%;
          background-color: currentColor;
          position: absolute;
          opacity: 0.75;
          right: 0;
          transform-origin: center;
          transform: translate3d(-50%, -1px, 0);
          top: 0;
        }
      }

    }

    span {
      font-size: 0.7rem;
    }

    &+& {
      font-size: 1rem;
    }
  }

  &__label {
    @media (min-width: 1280px) {
      min-width: 166px;
      margin: 0 14px 0 28px;
    }
  }

  &__badge {
    position: relative;
    display: flex;
  }

  &__label,
  &__badge {
    z-index: 1;
  }

  &__count {
    box-sizing: border-box;
    background-color: white;
    color: black;
    border-radius: 100px;
    margin-left: 1rem;
    align-self: center;
    user-select: none;
    font-weight: 500;
    width: 1.5rem;
    height: 1.5rem;
    font-size: 0.875rem;
    display: inline-flex;
    align-content: center;
    align-items: center;
    justify-content: center;

    @media (min-width: 1280px) {
      position: absolute;
      top: 18px;
      left: 18px;
      margin: 0;
    }
  }
}
</style>